import { render, staticRenderFns } from "./CreateWalletButtons.vue?vue&type=template&id=3c9ddac8&scoped=true"
import script from "./CreateWalletButtons.vue?vue&type=script&lang=js"
export * from "./CreateWalletButtons.vue?vue&type=script&lang=js"
import style0 from "./CreateWalletButtons.vue?vue&type=style&index=0&id=3c9ddac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ddac8",
  null
  
)

export default component.exports